import { FC } from 'react';
import _ from 'lodash';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

type SolutionSectionProps = {
  productName: string;
};

const SolutionSection: FC<SolutionSectionProps> = ({ productName }) => {
  return (
    <section className="solution-section ">
      <div className="solution-section__header">
        <h2>
          {_.capitalize(ApplicationDomainUtility.partnerName) || productName}&apos;s Innovative ok <span>Solutions</span>
        </h2>
      </div>
      <div className="solution-section__content__mobile">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="card">
              <div className="img-circle-mobile blue">
                <img src="/solution-0.svg" alt="Automate Strategy" />
              </div>
              <h3>Algo Strategies</h3>
              <p>
                Build scalable algo strategies in minutes that execute with precision and enhance your trading
                edge.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="card">
              <div className="img-circle-mobile red">
                <img src="/solution-2.svg" alt="Automate Strategy" />
              </div>
              <h3>Free Backtesting</h3>
              <p>
                Test your trading strategies on historical market data to refine performance before risking
                real capital.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="card">
              <div className="img-circle-mobile green">
                <img src="/solution-4.svg" alt="Automate Strategy" />
              </div>
              <h3>No-code</h3>
              <p>
                Easily create, test, and execute trading strategies without any programming or coding skills.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="card">
              <div className="img-circle-mobile yellow">
                <img src="/solution-3.svg" alt="Automate Strategy" />
              </div>
              <h3>Backtest with Historical Data</h3>
              <p>Evaluate the potential performance of your developed strategy using historical data.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
